import React, {Component, Fragment} from "react";
import "react-select/dist/react-select.css";
import {setSchemasTemplates, editSchema, getSchemaById, emptySchemas} from "../../../../store/actions";
import {connect} from "react-redux";
import {compose} from "redux";
import FormFileds from "./FormFields";

class EditSchema extends Component {
  state = {
    contracts: [],
    assets: {},
    epc: {},
    error: false,
  };

  componentDidMount() {
    this.props.emptySchemas();
    this.props.getSchemaById(this.props.match.params.id);
  }

  handleStateChange = (name, value, index) => {
    if (name === 'contracts') {
      let contracts = this.state.contracts;
      contracts[index] = value;
      this.setState({[name]: contracts})
    } else {
      this.setState({[name]: value});
    }
  };

  handleClick = async () => {
    let {contracts, assets, epc} = this.state;
    const {schemas} = this.props;
    const schemasTemplates = schemas.schema;
    let result = {
      name: schemasTemplates.user_schema.name,
      asset: {
        data: {},
        asset_schema_id: +schemasTemplates.assets.asset_schema_id,
      },
      contracts: [],
      epc: {
        data: {},
        epc_schema_id: +schemasTemplates.epc.epc_schema_id
      }
    };

    Object.keys(assets).map((key) => {
      if (typeof assets[key] !== 'object') {
        if (schemasTemplates.assets.data[key].type === 'number' || schemasTemplates.assets.data[key].type === 'integer') {
          result.asset.data[key] = +assets[key];
        } else {
          result.asset.data[key] = assets[key];
        }

      } else {
        result.asset.data[key] = typeof assets[key].key === 'boolean'
          ? assets[key].key
          : {name: assets[key].value, key: assets[key].key}
      }
    });
    contracts.map((contract, i) => {
      result.contracts[i] = {
        data: {},
        contract_schema_id: schemasTemplates.contracts[i].contract_schema_id,
      };
      Object.keys(contract).map((key) => {
        if (typeof contract[key] !== 'object') {
          if (schemasTemplates.contracts[i].data[key].type === 'number' || schemasTemplates.contracts[i].data[key].type === 'integer') {
            result.contracts[i].data[key] = +contract[key];
          } else {
            result.contracts[i].data[key] = contract[key];
          }
        } else {
          result.contracts[i].data[key] = typeof contract[key].key === 'boolean'
            ? contract[key].key
            : {name: contract[key].value, key: contract[key].key}
        }
      })
    });
    Object.keys(epc).map((key) => {
      if (typeof epc[key] !== 'object') {
        if (schemasTemplates.epc.data[key].type === 'number' || schemasTemplates.epc.data[key].type === 'integer') {
          result.epc.data[key] = +epc[key];
        } else {
          result.epc.data[key] = epc[key];
        }
      } else {
        result.epc.data[key] = typeof epc[key].key === 'boolean'
          ? epc[key].key
          : {name: epc[key].value, key: epc[key].key}
      }
    });
    const res = await this.props.editSchema(result, this.props.match.params.id);
    res.payload.status && this.setState({error: true});

    res.payload.detail === "successfully saved" &&
    this.props.history.push("/asset-schemas");
  };

  render() {
    const {schemas} = this.props;
    const {error} = this.state;


    return (
      <Fragment>
        <div className="animated fadeIn">
          <div className="row justify-content-center">
            <div className="col-lg-9 col-md-12 col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">{schemas.schema && schemas.schema.user_schema.name}</h4>
                </div>
                {schemas.hasOwnProperty('schema') && schemas.schema
                && <div className="card-body">
                  {error && <p style={{color: 'red'}}>something went wrong</p>}
                  <FormFileds headlineName={'Asset Type: '} dataOfSchemas={schemas.schema.assets}
                              type={'assets'} handleStateChange={this.handleStateChange}/>
                  {schemas.schema.contracts && schemas.schema.contracts.map((contract, i) => {
                    return (
                      <FormFileds headlineName={'Contract: '} dataOfSchemas={contract} key={i} type={'contracts'}
                                  index={i} handleStateChange={this.handleStateChange}/>
                    )
                  })}
                  <FormFileds headlineName={'EPC: '} dataOfSchemas={schemas.schema.epc} type={'epc'}
                              handleStateChange={this.handleStateChange}/>
                  <div className="row">
                    <div className="col-sm-12 text-right">
                      <button
                        className="btn btn-primary pl-4 pr-4"
                        onClick={this.handleClick}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    schemas: state.schemas
  };
};

export default compose(
  connect(
    mapStateToProps,
    {setSchemasTemplates, editSchema, getSchemaById, emptySchemas}
  ),
)(EditSchema);


// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/EditSchema/EditSchema.js